import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    Switch,
    CardActions,
    Box
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { isBoolean } from "lodash";

export default function EnableSmsTrackingUrlCard({
    onConfirm,
    otoTrackMessage,
    loading,
    error,
    isSuccess,
}) {

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false)

    useEffect(() => {
        if (isBoolean(otoTrackMessage)) {
            setChecked(otoTrackMessage)
        }
    }, [otoTrackMessage])

    const handleChange = (value) => {
        setChecked(value)
    }

    const onConfirmHandler = () => {
        onConfirm({ otoTrackMessage: checked })
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Activate sending tracking link via text message for Mapitship orders")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <FormControlLabel
                    control={
                        <Switch
                            checked={checked}
                            onChange={({ target: { checked } }) => handleChange(checked)}
                        />
                    }
                    label={t(checked ? "Enabled" : "Disabled")} />
            </CardContent>
            <Divider />
            <CardActions>
                {!!isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={onConfirmHandler}
                    disabled={otoTrackMessage === checked}
                >
                    {t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    );
};

